<a class="no-underline" target="_blank" rel="noopener noreferrer" [href]="data.link" (click)="$event.stopPropagation()">
  <div class="ml-auto mr-auto w-fit flex items-center">
    <div *ngIf="data?.text" class="mr-4">{{ data.text }}</div>
    <twaice-fe-svg-icon [size]="dense ? '20px' : '30px'" [name]="data.icon" [source]="data.iconSource ?? 'custom'">
    </twaice-fe-svg-icon>
  </div>
</a>
